module.exports = __webpack_public_path__ + "static/media/left-arrow.f46d65c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/ControlPanel/img/left-arrow.png
// module id = 949
// module chunks = 0